import { render, staticRenderFns } from "./declear.vue?vue&type=template&id=28ac07cc&scoped=true"
import script from "./declear.vue?vue&type=script&lang=js"
export * from "./declear.vue?vue&type=script&lang=js"
import style0 from "./declear.vue?vue&type=style&index=0&id=28ac07cc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ac07cc",
  null
  
)

export default component.exports